import { ProfilePhotoAndNameFeature } from 'feature/profile/profile-photo-and-name';
import { ProfileModuleHolder } from 'structure/profile';
import { CLICK, component, demoFile, extend, feature, INPUT, story, variant } from 'system/demo';

demoFile('feature/profile/profile-photo-and-name', {
    designUrl: 'https://www.figma.com/design/iP7DEaY8SVqQcEGN6Feipj/Basic-Profile-%2B-Privacy-Settings?node-id=188-1054&m=dev',
});

extend(
    'ProfileModuleHolder',
    'Profile Photo Editor (self)',
    ProfileModuleHolder,
    {
        args: {
            module: ProfilePhotoAndNameFeature.providesConfig?.profileModules?.[0],
        },
        instanceKey: 'a',
        state: {
            personaKey: 'a',
            modulePublic: { profile: { pseudonym: { takenname: 'b' } } },
            firebaseUser: { displayName: 'Alice Adams', photoURL: 'https://psi.zdf.de/faces/face9.jpeg' },
            serverCall: {
                profile: {
                    update: async ({ datastore, updates, preview }) => {
                        datastore.updateGlobalProperty('fields', updates);
                        datastore.updateObject('persona', 'a', preview);
                        return Promise.resolve();
                    },
                    checkName: async ({ name }) => Promise.resolve({ violates: name == 'meanword', looksreal: name == 'joebiden' }),
                },
            },
        },
    },
    [
        story('Good Pseudonym', [CLICK('Edit {tLabel}'), CLICK('Add a custom name'), INPUT('pseudonym', 'malice'), CLICK('Save')]),
        story('Empty pseudonym', [CLICK('Edit {tLabel}'), CLICK('Add a custom name'), INPUT('pseudonym', ''), CLICK('Save')]),
        story('Invalid', [CLICK('Edit {tLabel}'), CLICK('Add a custom name'), INPUT('pseudonym', 'XXX'), CLICK('Save')]),
        story('Violating', [CLICK('Edit {tLabel}'), CLICK('Add a custom name'), INPUT('pseudonym', 'meanword'), CLICK('Save')]),
        story('Looks real', [CLICK('Edit {tLabel}'), CLICK('Add a custom name'), INPUT('pseudonym', 'joebiden'), CLICK('Save')]),
        story('Taken', [CLICK('Edit {tLabel}'), CLICK('Add a custom name'), INPUT('pseudonym', 'takenname'), CLICK('Save')]),
        story('Back to full', [
            CLICK('Edit {tLabel}'),
            CLICK('Add a custom name'),
            INPUT('pseudonym', 'malice'),
            CLICK('Save'),
            CLICK('Edit {tLabel}'),
            CLICK('Alice Adams'),
            CLICK('Save'),
        ]),
        story('Cancel', [CLICK('Edit {tLabel}'), CLICK('Add a custom name'), INPUT('pseudonym', 'malice'), CLICK('Cancel')]),
        story('Letter Pic', [CLICK('Edit {tLabel}'), CLICK('letter'), CLICK('Save')]),
        story('Back to Photo', [
            CLICK('Edit {tLabel}'),
            CLICK('letter'),
            CLICK('Save'),
            CLICK('Edit {tLabel}'),
            CLICK('photo'),
            CLICK('Save'),
        ]),
        story('Photo and Pseudonym', [
            CLICK('Edit {tLabel}'),
            CLICK('letter'),
            CLICK('Add a custom name'),
            INPUT('pseudonym', 'malice'),
            CLICK('Save'),
        ]),
    ],
);

extend(
    'ProfileModuleHolder',
    'Profile Photo Editor (admin)',
    ProfileModuleHolder,
    {
        args: {
            module: ProfilePhotoAndNameFeature.providesConfig?.profileModules?.[0],
        },
        instanceKey: 'a',
        state: {
            personaKey: 'a',
            modulePublic: { profile: { pseudonym: { takenname: 'b' } } },
            roles: ['Owner'],
            firebaseUser: { displayName: 'Alice Adams', photoURL: 'https://psi.zdf.de/faces/face9.jpeg' },
            serverCall: {
                profile: {
                    update: async ({ datastore, updates, preview }) => {
                        datastore.updateGlobalProperty('fields', updates);
                        datastore.updateObject('persona', 'a', preview);
                        return Promise.resolve();
                    },
                    checkName: async ({ name }) => Promise.resolve({ violates: name == 'meanword', looksreal: name == 'joebiden' }),
                },
            },
        },
    },
    [
        story('Set Photo URL', [
            CLICK('Edit {tLabel}'),
            CLICK('Custom profile photo'),
            INPUT('photo-url', 'https://psi.zdf.de/faces/face1.jpeg'),
            CLICK('Save'),
        ]),
    ],
);

extend('ProfileModuleHolder', 'Profile Photo Editor (other user)', ProfileModuleHolder, {
    args: {
        module: ProfilePhotoAndNameFeature.providesConfig?.profileModules?.[0],
    },
    instanceKey: 'b',
    state: {
        personaKey: 'a',
    },
});

feature('profileedit', {
    structureKey: 'profile',
    instanceKey: 'a',
    features: {
        profileedit: true,
        profileeditname: true,
    },
    state: {
        globals: {
            initialized: true,
        },
    },
});
